import React from 'react';
import { Button, Typography, Space, Row, Col, Card, Image } from 'antd';
import { LoginOutlined } from '@ant-design/icons';
import yofiLogo from '../assets/logos/yofi.svg';

const { Title, Paragraph } = Typography;

const SignInPage = ({ onLogin, isLoading }) => {
  return (
    <Row justify="center" align="middle" style={{ minHeight: '80vh' }}>
      <Col xs={22} sm={20} md={16} lg={10}>
        <Card className="sign-in-card" style={{ 
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
          padding: '16px'
        }}>
          <Space direction="vertical" size="large" style={{ width: '100%', textAlign: 'center' }}>
            <Image
              src={yofiLogo}
              alt="Yofi Logo"
              preview={false}
              style={{ height: '80px', marginBottom: '12px' }}
            />
            <Title level={2} style={{ margin: '12px 0' }}>Service Center</Title>
            <Paragraph style={{ fontSize: '16px' }}>
              Sign in to access Yofi Service Center tools and services
            </Paragraph>
            <Button 
              type="primary" 
              size="large" 
              icon={<LoginOutlined />}
              onClick={onLogin}
              loading={isLoading}
              disabled={isLoading}
              style={{ 
                height: '48px', 
                fontSize: '16px', 
                width: '100%',
                maxWidth: '320px',
                margin: '16px auto 0'
              }}
            >
              Sign In
            </Button>
          </Space>
        </Card>
      </Col>
    </Row>
  );
};

export default SignInPage; 